/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexObjectDto } from '../../models/backend-capex-object-dto';
import { BackendCapexObjectRequestDto } from '../../models/backend-capex-object-request-dto';

export interface EconomicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this capex object.
   */
  id: number;
  body: BackendCapexObjectRequestDto;
}

export function economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexObjectDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexObjectDto>;
    }),
  );
}

economicIndicatorsCapexObjectSettingsUpdate$XWwwFormUrlencoded.PATH =
  '/api/economic_indicators/capex_object_settings/{id}/';
